import Axios from 'axios';

const token = localStorage.getItem('token');

export const api = Axios.create({
  baseURL: `${process.env.REACT_APP_UNLEASH_API}`,
  headers: {
    Accept: 'application/json',
    Authorization: token,
    token: token
  },
});
